import BenefitCard from './BenefitCard'
import './benefitsection.css'
import restaurantImage from './restaurant_benefit.png'
import chefImage from './chef_benefit.png'

const BenefitsSection = () => {
    const benefitsData = [
      {
        id: 1,
        title: 'EMPRESAS',
        descriptions: [
          'Activa tu perfil empresa y atrae talentos calificados.',
          'Publica ofertas y recibe candidatos ideales.',
          'Explora el buscador de talento y encuentra perfiles claves.',
          'Recibe CVs y crea tu propia base de talentos.'
        ],
        imageUrl: restaurantImage
      },
      { id: 2,
        title: 'TRABAJADORES',
        descriptions: [
          'Potencia tu perfil y consigue nuevas oportunidades.',
          'Postula a las mejores ofertas del sector gastronómico.',
          'Envía tu CV a empresas, incluso sin una oferta activa.',
          'Activa tu disponibilidad y cubre reemplazos urgentes.'
        ],
        imageUrl: chefImage
      }
    ];

    return (
      <div className="benefits-section__container">
        <div className="benefits-title__benefit_section">
         <h2>BENEFICIOS</h2>
         <h3>DESCUBRE LAS VENTAJAS DE GOURMETJOBS</h3>
        </div>
        <div className="benefits-section__benefits-cards">
          {benefitsData.map((benefit) => (
            <BenefitCard key={benefit.id} benefit={benefit} />
          ))}
        </div>
      </div>
    );
};

export default BenefitsSection;
